function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M12.7019 0L0 15.2679L0.641509 16.166L27.2 49.9094L54.4 15.2679L41.6981 0H12.7019ZM13.9849 2.69434H24.7623L17.1925 13.9849H4.49057L13.9849 2.69434ZM27.2 3.84906L34 13.8566H20.4L27.2 3.84906ZM4.36226 16.5509H16.9358L23.9925 41.5698L4.36226 16.5509ZM19.6302 16.5509H34.6415L27.2 42.7245L19.6302 16.5509ZM30.4075 41.4415L37.4641 16.5509H50.0377L30.4075 41.4415ZM37.2075 13.8566L29.6377 2.56604H40.4151L49.7811 13.8566H37.2075Z"
}));

var SvgProgramaEmblem = function SvgProgramaEmblem(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 55,
    height: 50,
    viewBox: "0 0 55 50",
    fill: "white",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgProgramaEmblem, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/programa_emblem.585ec17c.svg";
export { ForwardRef as ReactComponent };